import { QcNotesIssueType } from 'pages/Shows/Audiobooks/constants'
import { v4 as uuidv4 } from 'uuid'

const createDefaultQcNotes = () => {
  return {
    id: uuidv4(),
    time: '',
    issue_type: QcNotesIssueType[0],
    category: 'VOA',
    remarks: '',
    status: 'pending',
    new: true,
  }
}
export { createDefaultQcNotes }
